import { Flex, Switch } from 'antd';
import React from 'react';

/**
 * Styles that can only be done in CSS go in here
 */
import clsx, { ClassValue } from 'clsx';
import { Text } from 'components/mvp-typography';
import {
  DynamicOrStaticProperty,
  resolveDynamicOrStaticProperty
} from 'lib/utils/dynamic-or-static-property';

type ToggleWithLabelPropsBase = {
  checked: boolean;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  customStyles?: {
    flexStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
  };
};

export function ToggleWithLabel(
  props: (
    | {
        label: DynamicOrStaticProperty<string, boolean>;
      }
    | { label?: undefined; suffix?: string }
  ) &
    ToggleWithLabelPropsBase & {
      className?: ClassValue;
      switchClassName?: ClassValue;
    }
) {
  const label = resolveDynamicOrStaticProperty(
    props.label ??
      `${props.checked ? 'Hide' : 'Show'} ${props.suffix ?? 'scores'}`,
    props.checked
  );
  return (
    <Flex
      gap={'small'}
      align="center"
      style={props.customStyles?.flexStyle}
      className={clsx(props.className)}
    >
      <Text style={{ ...{ fontSize: 10 }, ...props.customStyles?.textStyle }}>
        {label}
      </Text>
      <Switch
        checked={props.checked}
        className={clsx(props.switchClassName)}
        onChange={(_state, event) => {
          event.preventDefault();
          props.setChecked?.(s => !s);
        }}
      />
    </Flex>
  );
}
